import { Drawer, Group } from '@mantine/core';
import { ReactComponent as IconKebab } from '../ContractItem/img/iconKebab.svg';
import { ReactComponent as IconClose } from '../ContractItem/img/iconCloseGray.svg';
import styles from './ReferenceActions.module.scss';
import { WorkerReference } from 'redux/Api/referencesApi/type';
import { ReferenceActionsContent } from './ReferenceActionsContent';
import { useState } from 'react';
import { ModalConfirm } from 'components/ContractItem/ModalConfirm';

export interface ReferenceActionsDrawerProps {
  reference: WorkerReference;
  workerId?: string;
}

export const ReferenceActionsDrawer: React.FC<ReferenceActionsDrawerProps> = ({
  reference,
  workerId,
}) => {
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [referenceModalContent, setReferenceModalContent] = useState<{
    title: string;
    text: string;
  }>({ title: '', text: '' });
  const [opened, setOpened] = useState(false);

  const handleShowError = (content: { title: string; text: string }) => {
    setReferenceModalContent(content);
    setShowReferenceModal(true);
  };

  const handleCloseModal = () => {
    setShowReferenceModal(false);
    setReferenceModalContent({ title: '', text: '' });
  };

  return (
    <>
      <IconKebab className={styles.kebabIcon} onClick={() => setOpened(true)} />
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        position='bottom'
        padding='md'
        withCloseButton={false}
        zIndex={100001}
        styles={{
          content: {
            height: 'fit-content',
            borderRadius: '13px 13px 0px 0px',
            backgroundColor: '#FFF',
            paddingBottom: '20px',
            boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
          },
          body: {
            padding: '0',
          },
        }}>
        <Group justify='space-between'>
          <div style={{ width: '20px' }}></div>
          <IconClose
            onClick={() => setOpened(false)}
            style={{
              width: '48px',
              height: '48px',
              padding: '12px',
            }}
          />
        </Group>
        <ReferenceActionsContent
          reference={reference}
          workerId={workerId}
          onItemClick={() => setOpened(false)}
          onShowError={handleShowError}
        />
      </Drawer>
      {showReferenceModal && (
        <ModalConfirm
          setShowLogoutModal={setShowReferenceModal}
          title={referenceModalContent.title}
          onConfirm={handleCloseModal}
          text={referenceModalContent.text}
          cancelText='Закрыть'
        />
      )}
    </>
  );
};
